// extracted by mini-css-extract-plugin
export var indeterminate = "_22-6";
export var md = "_22-5";
export var semantic = "_22-7";
export var sm = "_22-4";
export var text = "_22-8";
export var toggleControl = "_22-0";
export var toggleInput = "_22-1";
export var toggleSwitch = "_22-2";
export var xs = "_22-3";